export default function MiniToggle({ value, onChange, title, disabled }: {
  value: boolean; onChange: () => void; title?: string; disabled?: boolean;
}) {
  return (
    <div
      onClick={disabled ? undefined : onChange}
      title={title}
      style={{
        width: 30, height: 17, borderRadius: 10, cursor: disabled ? 'not-allowed' : 'pointer',
        position: 'relative', flexShrink: 0, opacity: disabled ? 0.4 : 1,
        background: value ? 'var(--green)' : 'var(--border)', transition: 'background 0.2s',
      }}
    >
      <div style={{
        position: 'absolute', top: 2, left: value ? 15 : 2, width: 13, height: 13, borderRadius: '50%',
        background: '#fff', transition: 'left 0.2s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
      }} />
    </div>
  );
}
